export default __webpack_public_path__ + "static/media/blaze-ecom.332cfeb4.svg";